import type { FeatureManifest } from './types';

/**
 * Fonction identité — sert à l'inférence de type et donne un point d'accroche
 * unique si l'on veut hooker une validation runtime plus tard. Cf.
 * docs/documentation-strategy.md § 9.2.
 */
export const defineFeature = (manifest: FeatureManifest): FeatureManifest => manifest;
